var image_upload_default = {
  "container": "x-50T",
  "disabled": "orEFO",
  "imageInput": "RGLpZ",
  "overlay": "KJVfd",
  "text": "lk5C5",
  "shown": "_5vscg",
  "hide": "Admkh",
  "spinner": "oYIRW",
  "spin": "EnDoJ"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
